var Curriculog = Curriculog || {};

Curriculog.CurrentStepDropdownView = (function ($, _, Backbone, CurrentStepDropdownView) {

    CurrentStepDropdownView = Curriculog.DropdownView.extend({
        render: function () {
            if (this.collection.length > 0 && this.disabledList.length <= this.collection.length) {
                var that = this;

                // Set the disabled propoerty to false on the select element if it was set
                // by renderEmptyList
                this.$el.prop('disabled', false);

                if (this.firstOption) {
                    this.createFirstOption();
                }

                this.collection.forEach(function (currentStepName) {
                    var model = {},
                        options = {selectedValue: that.selectedValue};

                    // Make the value the current step name as well so that we can
                    // filter the collection by the step name if an AP selection
                    // is selected
                    model = new Curriculog.CurrentStep({
                        value: currentStepName,
                        name: currentStepName,
                    });

                    that.createNewOption(model, options);
                });
            } else {
                this.renderEmptyList();
            }

            this.$el.append(this.container);
        },
    });
    return CurrentStepDropdownView;

})($, _, Backbone, Curriculog.CurrentStepDropdownView || {});
